import {
  dateOperating
} from '@/cllib/tools'

import {
  invoicingGetData
} from '@/api/api'

const state = {
  writeoffRelatedinvoicing: [],
  writeoffRelatedinvoicingLoading: false
}

const getters = {
  writeoffRelatedinvoicing: state => state.writeoffRelatedinvoicing,
  writeoffRelatedinvoicingLoading: state => state.writeoffRelatedinvoicingLoading
}

const actions = {
  loadWriteoffRelatedinvoicing ({ dispatch, getters }) {
    if (!getters.chooseWriteoffInvoicing.id) {
      dispatch('setWriteoffRelatedinvoicing', [])
      return
    }
    dispatch('setWriteoffRelatedinvoicingLoading', true)
    let chooseWriteoffInvoicingCollectTime = getters.chooseWriteoffInvoicingCollectTime
    let parm = {
      noPage: 1,
      mergeIdnull: 1,
      oilId: getters.chooseWriteoffInvoicing.oilId,
      gasId: getters.chooseWriteoffInvoicing.gasId,
      collectTime: dateOperating.computeDay({days: -5, date: chooseWriteoffInvoicingCollectTime, format: 'yy-mm-dd'}),
      endTime: dateOperating.computeDay({days: 5, date: chooseWriteoffInvoicingCollectTime, format: 'yy-mm-dd'})
    }
    invoicingGetData(parm).then((data) => {
      data.forEach((item) => {
        item.collectTimeS = item.collectTime ? item.collectTime.slice(5, 16) : '--'
        item.outVolume = parseInt(item.outVolume)
        item.inVolume = parseInt(item.inVolume || 0)
        item.disInVolume = parseInt(item.disInVolume || 0)
        item['inVolumeDiff'] = item['inVolume'] - item['disInVolume']
      })
      dispatch('setWriteoffRelatedinvoicing', data)
      dispatch('setWriteoffRelatedinvoicingLoading', false)
    }).catch((e) => {
      dispatch('setWriteoffRelatedinvoicingLoading', false)
    })
  },
  updateWriteoffRelatedInvoicingOne ({ commit, dispatch }, data) {
    commit('updateWriteoffRelatedInvoicingOne', data)
    dispatch('updateWriteoffInvoicingOne', data)
  },
  setWriteoffRelatedinvoicing ({ commit }, data) {
    commit('setWriteoffRelatedinvoicing', data)
  },
  setWriteoffRelatedinvoicingLoading ({ commit }, data) {
    commit('setWriteoffRelatedinvoicingLoading', data)
  }
}

const mutations = {
  setWriteoffRelatedinvoicing (state, data) {
    state.writeoffRelatedinvoicing = data
  },
  setWriteoffRelatedinvoicingLoading (state, data) {
    state.writeoffRelatedinvoicingLoading = data
  },
  updateWriteoffRelatedInvoicingOne (state, data) {
    state.writeoffRelatedinvoicing.forEach((item) => {
      let startTime = dateOperating.computeDay({days: -1, date: item.collectTime, format: 'stamps'})
      let endTime = dateOperating.computeDay({days: 0, date: item.collectTime, format: 'stamps'})
      let hisInTime = data.his.inTime ? dateOperating.formatDate({date: data.his.inTime, format: 'stamps'}) : null
      if (hisInTime && hisInTime > startTime && (hisInTime < endTime || hisInTime === endTime) && item.gasTankId === data.his.gasTankId) {
        item.disInVolume = item.disInVolume - data.his.inVolume
        item['inVolumeDiff'] = parseInt(item['inVolume'] - item['disInVolume'])
      }
      let newInTime = data.new.inTime ? dateOperating.formatDate({date: data.new.inTime, format: 'stamps'}) : null
      if (newInTime && newInTime > startTime && (newInTime < endTime || newInTime === endTime) && item.gasTankId === data.new.gasTankId) {
        item.disInVolume = item.disInVolume + data.new.inVolume
        item['inVolumeDiff'] = parseInt(item['inVolume'] - item['disInVolume'])
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/distribution_writeoff/writeoff_related_invoicing.js